
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';

/**
 * Ajoute des attachements aux dents correspondantes dans la scène.
 *
 * @param {THREE.Scene} scene - La scène Three.js contenant les dents.
 * @param {Array<THREE.Object3D>} attachments - Liste des attachements à ajouter.
 */
export function addAttachments(scene, inComparativeScene = false) {
    // Sélection du groupe de dents et des meshes selon le contexte
    const targetGroup = inComparativeScene
        ? threeEngine.getComparativeSceneGroup()
        : scene.children.find(child => child.name === "importedMeshes");

    if (!targetGroup) return;

    // Récupère uniquement les attachments (type === 2)
    const attachments = targetGroup.children.filter(obj => obj.userData.type === 2);

    attachments.forEach(attachment => {
        // Récupère le numéro de la dent depuis le nom de l'attachment
        const [, , toothId] = attachment.name.split("_");
        const targetTooth = targetGroup.children.find(child => child.name === `0_Tooth_${toothId}`);

        if (targetTooth) {
            targetTooth.add(attachment); // Attache l’attachment à la dent
            threeEngine.getAllAttachments().push(attachment); // Stocke l’attachment globalement
        }
    });
}
